// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"246dbf00","227":"16d17bad","275":"cd398970","289":"f2adfad0","453":"8701dc61","482":"89a0b7a0","648":"0635c08c","765":"5340a2a3"}[chunkId] + ".chunk.js";
};